/**
 * @powerby https://internal-fed.huya.info/h5/datacenter-tools/index.html
 */

import { report } from "@/utils/report";
/**
 * @file 虎牙web下载页更新文档 1011
 * @see https://datacenter.huya.info/events/#/common/demandDetail?id=20010043
 */

/**
 * @description 点击/通用下载按钮
 */
export const clickGeneralDownload = (prop: {
  /** 点击时的按钮名称。如下载windows版，下载mac版，ARM版本下载，立即下载等 */
  button_name: string;
  /** 下载的产品名称 values: 0: 虎牙直播客户端; 1: 虎牙直播移动端; 2: 云视听虎电竞; 3: 三角洲地图工具; 4: pc极速版客户端; 5: 奶瓶加速器; 6: 虎牙直播主播端*/
  product_name: string;
}) => {
  report({
    eid: "click/general_download",
    eid_desc: "点击/通用下载按钮",
    prop: JSON.stringify(prop),
  });
};

/**
 * @description 曝光/下载页tab页面
 */
export const showDownloadTabpage = (prop: {
  /**  values: 0: 电脑端; 1: 移动端; 2: 智能终端; 3: 更多产品*/
  tab: string;
}) => {
  report({
    eid: "show/download_tabpage",
    eid_desc: "曝光/下载页tab页面",
    prop: JSON.stringify(prop),
  });
};

/**
 * @description PV/下载页
 */
export const pageviewDownload = (prop: {
  /** 曝光时所展示的tab。 values: 0: 虎牙直播客户端; 1: 开播工具*/
  tab: string;
}) => {
  report({
    eid: "pageview/download",
    eid_desc: "PV/下载页",
    prop: JSON.stringify(prop),
  });
};
